/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="59.54"
        height="95.48"
        viewBox="0 0 59.54 95.48"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M29.81 0a29.77 29.77 0 1 0 29.73 29.81A29.77 29.77 0 0 0 29.81 0Zm0 2.5A27.27 27.27 0 1 1 2.54 29.77 27.26 27.26 0 0 1 29.81 2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="m42.1 18.93 2.12 2.12-17.1 17.1-10.73-10.74 2.12-2.12 8.61 8.62Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M48.7 50.5a1.23 1.23 0 0 1 1.29 1.07v.13l1.7 42.48a1.24 1.24 0 0 1-1.2 1.29 1.31 1.31 0 0 1-.62-.13l-.1-.06-20-12.8-20 12.8a1.26 1.26 0 0 1-1.74-.4 1.28 1.28 0 0 1-.19-.6v-.12l1.7-42.48a1.25 1.25 0 0 1 2.5 0v.13l-1.5 40.05 18.62-11.93a1.23 1.23 0 0 1 1.23-.07l.12.07 18.63 11.93-1.6-40.08a1.23 1.23 0 0 1 1-1.28Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'RibbonWithCheckmarkIcon';

export default Icon;
